module.exports = __webpack_public_path__ + "media/svg/fleche-c792962e.svg";